import Header from "@/components/layout/header/Header";
import Main from "@/components/layout/main/Main";
import Footer from "@/components/layout/footer/Footer";
import React from "react";

interface LayoutProps {
  children?: React.ReactNode;
}

export default function DefaultLayout({ children }: LayoutProps) {
  return (
    <>
      <Header></Header>
      <Main>{children}</Main>
      <Footer></Footer>
    </>
  );
}
